import React from "react";

import CONFIG from '../../config';
import EngineeringIcon from '@mui/icons-material/Engineering';
import HomeIcon from '@mui/icons-material/Home';
import NavbarLeftItem from "./NavbarLeftItem";
import SavingsIcon from '@mui/icons-material/Savings';
import PersonIcon from '@mui/icons-material/Person';
import WorkIcon from '@mui/icons-material/Work';
import { Button } from "@mui/material";
import RecentActorsIcon from '@mui/icons-material/RecentActors';


function NavbarLeftIntranet({ current }) {
  return (
    <>
      <div className="fixed z-49 w-36 min-h-full bg-ame-gray justify-between items-end flex flex-col">
        <div className="divide-y divide-gray-600 flex flex-col items-center justify-between bg-ame-gray text-white w-full min-h-full">
          <div className="w-full"></div>
          <NavbarLeftItem
            icon={
              <HomeIcon sx={{ fontSize: 40 }}></HomeIcon>
            }
            text={"Vue d'ensemble"}
            href={CONFIG.BASE_URL + "/intranet/vue_ensemble"}
          />
          <NavbarLeftItem
            icon={
              <WorkIcon sx={{ fontSize: 40 }}></WorkIcon>
            }
            text={"Commerciaux"}
            href={CONFIG.BASE_URL + "/intranet/commerciaux"}
            disabled={!(current.roles.role_admin_read || current.roles.role_admin_write)}
          />
          <NavbarLeftItem
            icon={
              <RecentActorsIcon sx={{ fontSize: 40 }}></RecentActorsIcon>
            }
            text={"Utilisateurs"}
            href={CONFIG.BASE_URL + "/intranet/utilisateurs"}
            disabled={!(current.roles.role_admin_read || current.roles.role_admin_write)}
          />
          <NavbarLeftItem
            icon={
              <SavingsIcon sx={{ fontSize: 40 }}></SavingsIcon>
            }
            text={"Comptabilité"}
            href={CONFIG.BASE_URL + "/intranet/comptabilite"}
            disabled={!(current.roles.role_comptable)}
          />
          <NavbarLeftItem
            icon={
              <EngineeringIcon sx={{ fontSize: 40 }}></EngineeringIcon>
            }
            text={"Configuration"}
            href={CONFIG.BASE_URL + "/intranet/configuration"}
            disabled={!(current.roles.role_admin_write)}
          />
          <NavbarLeftItem
            icon={
              <PersonIcon sx={{ fontSize: 40 }}></PersonIcon>
            }
            text={"Mes Infos"}
            href={CONFIG.BASE_URL + "/intranet/fiche/" + current._id}
            disabled={false}
          />
        </div>
        <div className="w-full h-44 text-center px-2">
          {/* <Button variant="contained" color="error">Supprimer mon compte</Button> */}
        </div>
      </div>
    </>
  );
}

export default NavbarLeftIntranet;